module.exports = __webpack_public_path__ + "img/14.1c2b5fb9.jpg";